export function parseCredentials(search: string) {
    const query = new URLSearchParams(search);
    return {
        exhibitorId: query.get('exhibitorId') || '',// || 'exhibitor5021',
        accessToken: query.get('accessToken') || ''// || 'orga-exhibitor5021.24mibvxkrv5rs2oizt1e1fa3e33b6d4f30a2gb3'
    }
}